import { Admin, type AuthProvider, CustomRoutes, type DataProvider, Login, Resource } from 'react-admin'
import { Route } from 'react-router-dom'

import { Layout } from '@/components/molecules/Layout'
import { HiddenPage } from '@/components/screens/HiddenPage'
import { ScaleList } from '@/components/screens/ScaleList'
import { ScaleShow } from '@/components/screens/ScaleShow'
import { SpecialEventCreate } from '@/components/screens/SpecialEventCreate'
import { SpecialEventEdit } from '@/components/screens/SpecialEventEdit'
import { i18nProvider } from '@/i18n'
import { bombeoTheme } from '@/theme'

export interface AppProps {
  dataProvider: DataProvider
  authProvider: AuthProvider
}

export const App = ({ dataProvider, authProvider }: AppProps) => (
  <Admin
    layout={Layout}
    authProvider={authProvider}
    dataProvider={dataProvider}
    i18nProvider={i18nProvider}
    theme={bombeoTheme(import.meta.env.MODE)}
    requireAuth
    loginPage={Login}
  >
    {}
    {}
    <Resource name="scales" list={ScaleList} show={ScaleShow} recordRepresentation="id" />
    <Resource name="scale_events" create={SpecialEventCreate} edit={SpecialEventEdit} />
    {}
    {}
    <CustomRoutes>
      <Route path="/hidden" element={<HiddenPage />} />
    </CustomRoutes>
  </Admin>
)
